import {Grid} from "@mui/material";
import {useSelector} from "react-redux";
import {isDataportalNode} from "../../../constants/nodes";
import UserItemsSelect from "../../user-items-select";
import {nodeSelector} from "../../../state/node/nodeSelectors";
import {
  canDisplayUserViews,
  canImportData,
  canManagePersonalDashboards,
  getIsUserAuthenticated
} from "../../../utils/permissions";

const UserItemsSelectButton = ({nodes, user, disabled, viewMode, onNavigate}) => {
  const moduleConfigs = useSelector(state => state.moduleConfigs);
  const node = useSelector(nodeSelector);

  const isViewsVisible = canDisplayUserViews(user);
  const isDashboardsVisible = moduleConfigs.modules.includes("dashboard") && canManagePersonalDashboards(user);
  const isPackageManagerVisible = Boolean(node?.nodeId) && isDataportalNode(node) && canImportData(user, node.nodeId);
  const hasModules = (moduleConfigs.placeholders?.["user-items-select-menu"] || []).length > 0;

  const isUserItemsSelectVisible =
    getIsUserAuthenticated(user) && (isViewsVisible || isDashboardsVisible || isPackageManagerVisible || hasModules);

  if (isUserItemsSelectVisible) {
    return (
      <Grid className="user-settings-btn">
        <UserItemsSelect
          nodes={nodes}
          disabled={disabled}
          viewMode={viewMode}
          onNavigate={onNavigate}
          isViewsVisible={isViewsVisible}
          isDashboardsVisible={isDashboardsVisible}
          isPackageManagerVisible={isPackageManagerVisible}
        />
      </Grid>
    );
  } else {
    return null;
  }
};

export default UserItemsSelectButton;
